import { render, staticRenderFns } from "./BlocksBiolinkConfig.vue?vue&type=template&id=5dc54164&scoped=true&"
import script from "./BlocksBiolinkConfig.vue?vue&type=script&lang=js&"
export * from "./BlocksBiolinkConfig.vue?vue&type=script&lang=js&"
import style0 from "./BlocksBiolinkConfig.vue?vue&type=style&index=0&id=5dc54164&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc54164",
  null
  
)

export default component.exports